import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import SetMachineTypeForm from "../../../../components/GeneralForm/SetMachineTypeForm";
import McTypeService from "../../../../services/mctype.service";

export default function AddSetMachineType() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  return (
    <>
      <Helmet>
        <title>เพิ่ม MC Type</title>
        <meta name="description" content="Add Machine Type Page" />
      </Helmet>

      <Container fluid className="p-3">
        <SetMachineTypeForm
          onSubmitCallback={(data) => {
            addEditServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: McTypeService.createMcTypes(data),
              navigated: (navi) => navi && navigate(0)
            });
          }}
        />
      </Container>
    </>
  );
}
